module.exports = __webpack_public_path__ + "static/media/logo-with-title.dfb3729d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo-with-title.svg
// module id = 202
// module chunks = 0